function initGiftModal() {
    document.querySelector(".gift_popup_modal").innerHTML = `
    <div class="gift-modal" style="display: block;">
        <div class="gift-modal-content modal-gift-popup">
            <div class="modal-header">
                <span class="gift-close close-gift-popup" role="button">
                    <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.28214 8.56196L22.4095 22.6893C22.6622 22.942 22.9811 22.9906 23.15 22.8217L23.775 22.1967C23.9608 22.0109 23.9122 21.692 23.6595 21.4393L9.53216 7.31194C9.27947 7.05926 8.96057 7.01063 8.77475 7.19644L8.14974 7.82145C7.98082 7.99037 8.02945 8.30928 8.28214 8.56196Z" fill="#949494"/>
                        <path d="M22.4097 7.31216L8.28237 21.4395C8.02969 21.6922 7.98106 22.0111 8.14998 22.18L8.77499 22.805C8.9608 22.9908 9.27971 22.9422 9.53239 22.6895L23.6597 8.56219C23.9124 8.3095 23.9611 7.9906 23.7752 7.80478L23.1502 7.17977C22.9813 7.01085 22.6624 7.05948 22.4097 7.31216Z" fill="#949494"/>
                    </svg>   
                </span>
            </div>
          <div class="gift-modal-body modal-gift-body">
            <div class="gift-modal-header"> GIFT NOTE </div>
            <div class="gift-modal-prompt"> Is this a gift? Enter a special message for the purchase below. </div>
            <textarea class="text-area gift-modal-text-area" id="story" name="story" rows="5" cols="33" style="padding: 1rem; margin-bottom: 16px;"></textarea>
            <div class="slide-btn gift-modal-btn" role="button">SUBMIT</div>
            <div class="slide-btn not-gift-modal-btn" role="button">NOT A GIFT</div>
          </div>
        </div>
    </div>
    `;
  }
  
  function changeGiftNote(value){
    sessionStorage.setItem("gift_modal_content", value);
  }

  function addGiftNote(gift_modal_textarea, cart_textarea) {
    var gift_note_input = gift_modal_textarea.value;
    cart_textarea.value = gift_note_input;
    updateCartNote(gift_note_input);
  }
  
  function closeGiftModal() {
    document.querySelector(".gift_popup_modal").innerHTML = ``;
    document.querySelector("body").classList.remove("lock__background");
  }
  
  window.addEventListener("load", event => {
    var cart_textarea = document.querySelector('.cart__note .text-area');
    cart_textarea.value = sessionStorage.getItem("gift_modal_content");
    console.log(cart_textarea.value)

    cart_textarea.addEventListener("input", event => {
      changeGiftNote(cart_textarea.value);
    })

    if(sessionStorage.getItem("gift_modal_popup") == "1"){
      //WE DONT WANT TO SHOW GIFT NOTE POPUP ANYMORE
    }
    else {
      //ONLY SHOW ON INITIAL LOAD OF THE CART PAGE
      sessionStorage.setItem("gift_modal_popup", "1");
      initGiftModal();

      var gift_modal_textarea = document.querySelector(".gift-modal-text-area");
  
      document.querySelector("body").classList.add("lock__background");
  
      document.querySelector(".gift-modal-btn").addEventListener("click", event => {
        console.log('CLICKS SUBMIT')
        addGiftNote(gift_modal_textarea, cart_textarea);
        closeGiftModal();
      })
  
      document.querySelector(".close-gift-popup").addEventListener("click", event => {
        closeGiftModal();
      })

      document.querySelector(".not-gift-modal-btn").addEventListener("click", event => {
        closeGiftModal();
      })

      gift_modal_textarea.addEventListener("input", event => {
        changeGiftNote(gift_modal_textarea.value);
      })
    }

  })


  function getCart(){
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      console.log('Success', response)
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  function updateCartNote(gift_note_input){
    let noteData = {
      note: gift_note_input
    };
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(noteData)
    })
    .then(response => {
      console.log('Success', response)
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }